import { render } from "./AddMatch.vue?vue&type=template&id=c6135ede&scoped=true"
import script from "./AddMatch.vue?vue&type=script&lang=js"
export * from "./AddMatch.vue?vue&type=script&lang=js"

import "./AddMatch.vue?vue&type=style&index=0&id=c6135ede&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6135ede"]])

export default __exports__